<template>
  <div>
    <!--Rows-->
    <div class="participant-signatures bg-secondary-3 border-radius--light">
      <div v-for="(item, index) in localValue" :key="index">
        <EvaluationDiscussionATRow
          :id="index"
          :ref="`signatureRow-${index}`"
          class="participant"
          :is-disabled="!isDraft || item.isDisabled || readOnly"
          :is-required="item.isRequired"
          v-model="localValue[index].signature"
          :is-removable="item.isRemovable && isDraft"
          :position-disabled="item.positionDisabled"
          :options="filterOptions(item.groupId)"
          :group-name="getGroupName(item)"
          :participation-types="participationTypes"
          :participation-disabled="item.participationDisabled"
          :alternate-participations="alternateParticipations"
          :fullname-only="fullnameOnly"
          @update:participationTypes="
            () => $emit('update:participationTypes', item.participationId)
          "
          @deleteSignature="deleteSignature"
        />
      </div>
    </div>
    <div v-if="isDraft && !readOnly" class="text-right mt-4">
      <div class="mx-0 bd-highlight ml-2">
        <ActionButton
          :variant="isMobile ? 'success btn-block' : 'success'"
          class="px-1 actions p-2 m-2"
          i="fas fa-file-plus"
          @click="addSignature()"
        >
          A&ntilde;adir
        </ActionButton>
      </div>
      <Error
        v-if="infoMessage != undefined && infoMessage != ''"
        class="m-2"
        is-alert-mode
        :message="infoMessage"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.participant-signatures {
  .participant {
    padding: 1rem;
  }
  .participant:not(:first-child) {
    border-top: 2px solid gray;
  }
}
</style>

<script>
import EvaluationDiscussionATRow from './EvaluationDiscussionATRow';
import ActionButton from 'ActionButton';
import Error from '@/components/common/Error.vue';

export default {
  name: 'EvaluationDiscussionATSignatures',
  components: {
    EvaluationDiscussionATRow,
    ActionButton,
    Error,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    signatures: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    participationTypes: {
      type: Array,
      default: () => [],
    },
    alternateParticipations: {
      type: Array,
      default: () => [],
    },
    infoMessage: {
      type: String,
      default: '',
    },
    allowedGroupList: {
      type: Array,
      default: () => [1, 4, 5, 15, 16],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    fullnameOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localValue: JSON.parse(JSON.stringify(this.value || [])),
    };
  },
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.localValue)) {
          this.localValue = Array.isArray(newVal)
            ? newVal.map((v) => ({ ...v }))
            : newVal;
        }
      },
    },
    localValue: {
      deep: true,
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
          this.$emit('input', newVal);
        }
      },
    },
  },
  methods: {
    addSignature() {
      this.$emit('addSignature');
    },
    deleteSignature(id) {
      this.$emit('deleteSignature', id);
    },
    filterOptions(groupId) {
      if (groupId !== 0) {
        return this.options.filter((x) => x.signatureGroupId == groupId);
      }

      const filteredOptions = this.options.filter((x) =>
        this.allowedGroupList.includes(x.signatureGroupId)
      );

      const defaultSignatures = this.options.filter(
        (x) =>
          x.signatureGroupId == 13 &&
          !filteredOptions.some(
            (g) => g.signaturePositionId == x.signaturePositionId
          )
      );

      return filteredOptions.concat(defaultSignatures);
    },
    getGroupName(item) {
      let groupId =
        item.signature?.positionId?.signatureGroupId || item.groupId;
      // JSF: Si el groupId viene 0 es que estan agregando una agencia desde la seccion de la parte
      // (IX. Participación de la familia y otras agencias del TAB 9). Asi que añadimos un nombre por defecto
      // porque no encontrara el nombre del grupo.
      const defaultSignatureGroupName =
        groupId === 0 || groupId === 13
          ? 'Otras personas con experiencia o peritaje'
          : '';

      const signatureGroup = this.options.find(
        (x) => x.signatureGroupId == groupId
      );
      if (signatureGroup && item.groupId === 0) {
        item.groupId = signatureGroup.signatureGroupId;
      }

      return defaultSignatureGroupName || signatureGroup?.signatureGroupName;
    },
    async validate() {
      let isValid = true;
      for (const [index] of this.localValue.entries()) {
        const ref = this.$refs[`signatureRow-${index}`]?.[0];
        if (ref?.validate) {
          const signValid = await ref.validate();
          isValid &&= signValid;
        }
      }

      return isValid;
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
};
</script>
